/**
 * Pilot lender logos ship as static SVGs under
 * `public/images/financing/lenders/<slug>.svg`. Cloudinary `logoIcon`
 * URLs from the API take precedence when present.
 */
export function resolvePilotLenderLogoUrl(
  slug: string,
  logoUrl?: string,
): string | undefined {
  if (logoUrl) return logoUrl;
  if (!slug) return undefined;
  return `/images/financing/lenders/${slug}.svg`;
}
